import { mapProductImagesFromApi } from "@/lib/catalog/productsStore";
import { normalizeProductMediaUrlForBrowser } from "@/lib/mediaUrls";

type ThumbnailSource = {
  image_url?: string | null;
  imageUrl?: string | null;
  product_images?: unknown;
  productImages?: unknown;
} | null | undefined;

/** First product image URL for cards, pickers, and sale views. */
export function resolveProductThumbnailUrl(source: ThumbnailSource): string | null {
  if (!source) return null;

  const direct = source.image_url ?? source.imageUrl;
  if (typeof direct === "string" && direct.trim() !== "") {
    return normalizeProductMediaUrlForBrowser(direct.trim());
  }

  const images = mapProductImagesFromApi(source.product_images ?? source.productImages).filter((u) =>
    Boolean(u.url),
  );
  return images[0]?.url ?? null;
}
